/**
 * Leaf API for the "is sheets enabled" probe.
 *
 * Split out of `sheet-api.ts` so shell-side hooks (`use-sheets-feature`,
 * `use-sheets-v2-feature`) can import this without pulling the full
 * SheetApi class — which drags in `sheet-types.tsx` (JSX-bearing) and
 * `newTemplateData.ts` (454 lines) and then the rest of the sheets
 * graph into the app chunk.
 */
import { HttpClient } from 'api/home';

class SheetFeatureHttpClient extends HttpClient {
  public isSheetsEnabled = (accountId: number): Promise<{ enabled: boolean }> =>
    this.get('/sheets/enable', {
      params: {
        accountId,
      },
    });

  public isSheetsV2Enabled = (
    accountId: number,
  ): Promise<{ enabled: boolean }> =>
    this.get('/sheets/enable-v2', {
      params: {
        accountId,
      },
    });
}

export const SheetFeatureApi = new SheetFeatureHttpClient();
